import type { RouteRecordRaw } from 'vue-router';

import { BasicLayout } from '#/layouts';

/**
 * 客户端概况菜单（P1-06）：
 * - 默认首页为待办/Banner 业务首页
 * - 旧「平台概览」下线：菜单不展示；访问 /dashboard/index 重定向到 /dashboard/home
 */
const routes: RouteRecordRaw[] = [
  {
    component: BasicLayout,
    meta: {
      icon: 'pajamas:overview',
      order: 0,
      title: '概况',
      keepAlive: true,
      isSubMenuMore: true,
    },
    path: '/dashboard',
    redirect: '/dashboard/home',
    name: 'DashboardBase',
    children: [
      {
        name: 'WorkspaceHome',
        path: 'home',
        component: () => import('#/views/workspace/home/index.vue'),
        meta: {
          affixTab: true,
          icon: 'lucide:home',
          title: '首页',
          keepAlive: true,
          order: 0,
        },
      },
      {
        // 兼容书签/历史链接：不再展示「平台概览」菜单
        name: 'DashboardLegacyRedirect',
        path: 'index',
        redirect: '/dashboard/home',
        meta: {
          hideInMenu: true,
          title: '平台概览（已下线）',
          order: 99,
        },
      },
    ],
  },
];

export default routes;
